import { CustomObject } from '../types/data';

const Proxy = {
  on: (
    type: any,
    listener: (this: Window, ev: any) => any,
    options?: boolean | AddEventListenerOptions | undefined
  ) => {
    window.addEventListener(type, listener, options);
  },
  emit: (event: string, data: any) => {
    try {
      window.postMessage(
        {
          event,
          data,
        },
        '*'
      );

      if (window.parent !== window) {
        window.parent.postMessage(
          {
            event,
            data,
          },
          '*'
        );
      }
    } catch (e) {
      console.log('GatewayService.emit: error: ', e);
    }
  },
};

class GatewayService {
  private proxy: typeof Proxy;
  private listeners: CustomObject;

  constructor() {
    this.proxy = Proxy;

    this.listeners = {};

    this.proxy.on('message', this.handleMessage);
  }

  private handleMessage = (payload: any = {}) => {
    const { event, data } = payload.data || {};

    const listeners = this.listeners[event];

    if (Array.isArray(listeners)) {
      listeners.forEach(listener => listener(data, event));
    }
  };

  public on(event: string, listener: (...args: any[]) => void) {
    if (!Array.isArray(this.listeners[event])) this.listeners[event] = [];

    this.listeners[event].push(listener);
  }

  public off(event: string, listener: (...args: any[]) => void) {
    if (Array.isArray(this.listeners[event])) {
      const index = this.listeners[event].indexOf(listener);

      if (index > -1) {
        this.listeners[event].splice(index, 1);

        if (!this.listeners[event].length) {
          delete this.listeners[event];
        }
      }
    }
  }

  public emit(event: string, data: any) {
    // try {
    //   data = JSON.stringify(data);
    // } catch {}

    this.proxy.emit(event, data);
  }

  public getProxy(): typeof Proxy {
    return this.proxy;
  }
}

export default new GatewayService();
